import { usePlanIsRequest as useIsRequest } from "@/components/features/items/edit/plan/_shared/ui/components/plan-attributes/is-request/hooks";

import { useProductPlanFormModelContext } from "../../../../context";

export const usePlanIsRequest = () => {
	const { viewModel, onSetViewModel } = useProductPlanFormModelContext();
	const { isRequest } = viewModel;

	return useIsRequest({
		isRequest,
		onSetViewModel,
	});
};
